import { ParserDocuments, ParserField } from "./constants";
import { ParserDocument, ParserFieldKey, ParserFieldName } from "./enums";
import { ParserParseRequest, ParserRequest } from "./repo";

import { getDate } from "@/shared/utils/moment-helpers";
import { MomentFormat } from "@/shared/constants/enums";

export const ParserParseRequestFactory = (
  data: ParserRequest,
  fileName: ParserDocument,
  prefix: string = ""
): ParserParseRequest => {
  return {
    file: ParserDocuments[fileName],
    fileName,
    fields: (
      ParserField[
        fileName as unknown as keyof typeof ParserField
      ] as unknown as string[]
    ).map((field: string) => {
      return {
        fieldName: field,
        fieldText: ParserParseFieldText(field, data, prefix),
      };
    }),
  };
};

export const ParserParseFieldText = (
  field: string,
  data: ParserRequest,
  prefix: string
): string => {
  let fieldText = "";

  switch (field) {
    case ParserFieldName["_АдресФизЛицо_"]:
      if (data.address) {
        const { country, city, state, street, office, zip } = data.address;

        fieldText = `${country}, ${city}, ${state}, ${street}, ${office}, ${zip}`;
      }

      break;
    case ParserFieldName["_ТекущаяДАТА_"]:
      fieldText = getDate(new Date(), MomentFormat.dateReverse);

      break;
    case ParserFieldName["_НомерДоговор_"]:
      fieldText = `${prefix}-${data.id!}`;
      // fieldText = `${prefix}-${data.id || ""}`;

      break;
    case ParserFieldName["_ИНН_"]:
      fieldText = (data.inn as string) || "";

      break;
    case ParserFieldName["_НомерТелефона_"]:
      fieldText = (data.phone as string) || "";

      break;
    case ParserFieldName["_email_"]:
      fieldText = (data.email as string) || "";

      break;
    case ParserFieldName["_ЮрАдрес_"]:
      fieldText = (data.legalAddress as string) || "";

      break;
    case ParserFieldName["_телефон_"]:
      fieldText = (data.phone as string) || "";

      break;
    case ParserFieldName["_Капитал_"]:
      fieldText = (data.capital as string) || "";

      break;
    case ParserFieldName["_ВалютаКапитал_"]:
      fieldText = (data.capital_currency as string) || "";

      break;
    case ParserFieldName["_виддеят_"]:
      fieldText = (data.business_area as string) || "";

      break;
    case ParserFieldName["_ФамилияДир_"]:
      fieldText = (data.director_sur_name as string) || "";

      break;
    case ParserFieldName["_ИмяДир_"]:
      fieldText = (data.director_name as string) || "";

      break;
    case ParserFieldName["_ОтчествоДир_"]:
      fieldText = (data.director_patronymic as string) || "";

      break;
    case ParserFieldName["_ФамилияДол_"]:
      fieldText = (data.officer_sur_name as string) || "";

      break;
    case ParserFieldName["_ИмяДол_"]:
      fieldText = (data.officer_name as string) || "";

      break;
    case ParserFieldName["_ОтчествоДол_"]:
      fieldText = (data.officer_patronymic as string) || "";

      break;
    case ParserFieldName["_ФамилияБен_"]:
      fieldText = (data.beneficiary_sur_name as string) || "";

      break;
    case ParserFieldName["_ИмяБен_"]:
      fieldText = (data.beneficiary_name as string) || "";

      break;
    case ParserFieldName["_ОтчествоБен_"]:
      fieldText = (data.beneficiary_patronymic as string) || "";

      break;
    case ParserFieldName["_доля_"]:
      fieldText = (data.share_in_org as string) || "";

      break;
    default:
      fieldText = data[
        ParserFieldKey[field as keyof typeof ParserFieldName]
      ] as string;

      break;
  }

  return fieldText;
};
